export interface SettingDefinition {
  settingKey: string;
  displayName: string;
  description?: string;
  category: string;
  dataType: SettingDataType;
  defaultValue?: string;
  allowSystemLevel: boolean;
  allowProfileLevel: boolean;
  validationRules?: string;
  displayOrder: number;
  isActive: boolean;
  createdBy?: string;
  created: string;
  updatedBy?: string;
  lastUpdate?: string;
}

export interface CreateSettingDefinitionRequest {
  settingKey: string;
  displayName: string;
  description?: string;
  category: string;
  dataType: SettingDataType;
  defaultValue?: string;
  allowSystemLevel: boolean;
  allowProfileLevel: boolean;
  validationRules?: string;
  displayOrder: number;
}

export interface UpdateSettingDefinitionRequest {
  displayName: string;
  description?: string;
  category: string;
  dataType: SettingDataType;
  defaultValue?: string;
  allowSystemLevel: boolean;
  allowProfileLevel: boolean;
  validationRules?: string;
  displayOrder: number;
  isActive: boolean;
}

export type SettingDataType = 'String' | 'Int' | 'Bool' | 'Decimal' | 'DateTime' | 'Json';

export const SETTING_DATA_TYPES: SettingDataType[] = ['String', 'Int', 'Bool', 'Decimal', 'DateTime', 'Json'];

// Kategorikatalogen styres av master-tabellen SettingCategory (hentes via API) —
// ingen hardkodet liste her lenger.
export interface SettingCategory {
  categoryKey: string;
  displayName: string;
  displayOrder: number;
  isActive: boolean;
}

export const DATA_TYPE_LABELS: Record<SettingDataType, string> = {
  String: 'Tekst',
  Int: 'Heltall',
  Bool: 'Ja/Nei',
  Decimal: 'Desimaltall',
  DateTime: 'Dato/tid',
  Json: 'JSON'
};

export interface ValidationRules {
  min?: number;
  max?: number;
  regex?: string;
  allowedValues?: string[];
  required?: boolean;
}

export function parseValidationRules(json?: string): ValidationRules | null {
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}
